const STORAGE_KEY = 'tms_preferences'

const DEFAULTS = {
  itemsPerPage: 10,
  defaultDateRange: 7,
  tableSortSettings: {},
  tableColumnSettings: {},
}

function loadFromStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (raw) {
      return JSON.parse(raw)
    }
  } catch (_) {
    // Intentional: ignore corrupted localStorage
  }
  return null
}

function saveToStorage(state) {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      itemsPerPage: state.itemsPerPage,
      defaultDateRange: state.defaultDateRange,
      tableSortSettings: state.tableSortSettings,
      tableColumnSettings: state.tableColumnSettings,
    })
  )
}

export default {
  namespaced: true,

  state: {
    itemsPerPage: DEFAULTS.itemsPerPage,
    defaultDateRange: DEFAULTS.defaultDateRange,
    tableSortSettings: { ...DEFAULTS.tableSortSettings },
    tableColumnSettings: { ...DEFAULTS.tableColumnSettings },
  },

  getters: {
    getTableSort: (state) => (viewName) => {
      return state.tableSortSettings[viewName] || null
    },
    getTableColumns: (state) => (tableId) => {
      return state.tableColumnSettings[tableId] || null
    },
  },

  mutations: {
    SET_ITEMS_PER_PAGE(state, value) {
      state.itemsPerPage = value
    },
    SET_DEFAULT_DATE_RANGE(state, value) {
      state.defaultDateRange = value
    },
    SET_TABLE_SORT(state, { viewName, sortBy, sortDesc }) {
      state.tableSortSettings = {
        ...state.tableSortSettings,
        [viewName]: { sortBy, sortDesc },
      }
    },
    CLEAR_TABLE_SORT(state, viewName) {
      const updated = { ...state.tableSortSettings }
      delete updated[viewName]
      state.tableSortSettings = updated
    },
    CLEAR_ALL_TABLE_SORTS(state) {
      state.tableSortSettings = {}
    },
    SET_TABLE_COLUMNS(state, { tableId, visible, order }) {
      state.tableColumnSettings = {
        ...state.tableColumnSettings,
        [tableId]: { visible, order },
      }
    },
    CLEAR_TABLE_COLUMNS(state, tableId) {
      const updated = { ...state.tableColumnSettings }
      delete updated[tableId]
      state.tableColumnSettings = updated
    },
    CLEAR_ALL_TABLE_COLUMNS(state) {
      state.tableColumnSettings = {}
    },
    LOAD_ALL(state, saved) {
      if (saved.itemsPerPage !== undefined) {
        state.itemsPerPage = saved.itemsPerPage
      }
      if (saved.defaultDateRange !== undefined) {
        state.defaultDateRange = saved.defaultDateRange
      }
      if (saved.tableSortSettings !== undefined) {
        state.tableSortSettings = saved.tableSortSettings
      }
      if (saved.tableColumnSettings !== undefined) {
        state.tableColumnSettings = saved.tableColumnSettings
      }
    },
  },

  actions: {
    loadPreferences({ commit }) {
      const saved = loadFromStorage()
      if (saved) {
        commit('LOAD_ALL', saved)
      }
    },

    setItemsPerPage({ commit, state }, value) {
      commit('SET_ITEMS_PER_PAGE', value)
      saveToStorage(state)
    },

    setDefaultDateRange({ commit, state }, value) {
      commit('SET_DEFAULT_DATE_RANGE', value)
      saveToStorage(state)
    },

    setTableSort({ commit, state }, payload) {
      commit('SET_TABLE_SORT', payload)
      saveToStorage(state)
    },

    clearTableSort({ commit, state }, viewName) {
      commit('CLEAR_TABLE_SORT', viewName)
      saveToStorage(state)
    },

    clearAllTableSorts({ commit, state }) {
      commit('CLEAR_ALL_TABLE_SORTS')
      saveToStorage(state)
    },

    setTableColumns({ commit, state }, { tableId, visible, order }) {
      commit('SET_TABLE_COLUMNS', { tableId, visible, order })
      saveToStorage(state)
    },

    clearTableColumns({ commit, state }, tableId) {
      commit('CLEAR_TABLE_COLUMNS', tableId)
      saveToStorage(state)
    },

    clearAllTableColumns({ commit, state }) {
      commit('CLEAR_ALL_TABLE_COLUMNS')
      saveToStorage(state)
    },

    resetPreferences({ commit, state }) {
      commit('LOAD_ALL', {
        ...DEFAULTS,
        tableSortSettings: {},
        tableColumnSettings: {},
      })
      saveToStorage(state)
    },
  },
}
